// GENERATED FILE - DO NOT EDIT.
// Source: backend/tests/snapshots/openapi_contract.json, via `npm run gen:api` (orval).
// Regenerate after the API contract changes; `npm run check:gen-api` fails when this is stale.
import * as zod from 'zod';

export const expertInLabelOneMax = 80;

export const ExpertIn = zod.object({
  "label": zod.union([zod.string().max(expertInLabelOneMax),zod.null()]).optional(),
  "user_id": zod.uuid()
});

export type ExpertIn = zod.input<typeof ExpertIn>;
export type ExpertInOutput = zod.output<typeof ExpertIn>;
